import { fromJS } from 'immutable';
import {SHOW_ALERT, HIDE_ALERT, SAVE_USER_IMAGE_BASE46, SAVE_USER_SIGN_BASE46, SAVE_ORG_IMAGE_BASE64} from '../constants/actions';

export function miscellaneousReducer(state = fromJS({}), action) {
    switch (action.type) {
        case SHOW_ALERT:
            /* tslint:disable */

            return state.set('alert', action.params).set('alertType', action.alertType).set('autoClose', action.autoClose);
        case HIDE_ALERT:
            return state.delete('alertType');
        case SAVE_USER_IMAGE_BASE46:
            return state.set('userImageBase64', action.imageBase64);
        case SAVE_USER_SIGN_BASE46:
            return state.set('userSignBase64', action.signBase64);
        case SAVE_ORG_IMAGE_BASE64:
            return state.set('orgImageBase64', action.imageBase64)
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/miscellaneousReducer.ts